export default {
  "HitPaw Online Audio Joiner": "HitPaw ऑनलाइन ऑडियो जॉइनर",
  "Merge Audio": "ऑडियो मिलाएं",
  "Merge multiple audio tracks into one.": "एकाधिक ऑडियो ट्रैक को एक में मिलाएं।",
  "Merge New": "नया मिलाएं",
  "Merge failed": "मिलाना विफल",
  "Fade in": "फेड इन",
  "Fade out": "फेड आउट",
  "Add tracks": "ट्रैक जोड़ें",
  "Format": "फॉर्मेट",
};
